// Create a new dedicated service for token management
export const AUTH_TOKEN_KEY = 'token';

/**
 * Centralized token management service
 */
export const tokenService = {
  /**
   * Store token in all available storage mechanisms
   */
  setToken(token: string): void {
    console.log('🔑 [TokenService] setToken called with:', {
      hasToken: !!token,
      tokenLength: token?.length
    });
    
    if (!token) {
      console.error('🔑 [TokenService] Attempting to store empty token');
      return;
    }
    
    try {
      localStorage.setItem(AUTH_TOKEN_KEY, token);
      sessionStorage.setItem(AUTH_TOKEN_KEY, token);
      
      // Verify immediately
      const localVerify = localStorage.getItem(AUTH_TOKEN_KEY);
      const sessionVerify = sessionStorage.getItem(AUTH_TOKEN_KEY);
      
      console.log('🔑 [TokenService] Token storage verification:', {
        localStorage: {
          stored: !!localVerify,
          matches: localVerify === token,
          length: localVerify?.length
        },
        sessionStorage: {
          stored: !!sessionVerify,
          matches: sessionVerify === token,
          length: sessionVerify?.length
        }
      });
    } catch (error) {
      console.error('🔑 [TokenService] Error storing token:', error);
    }
  },
  
  /**
   * Get token from storage (tries multiple sources)
   */
  getToken(): string | null {
    console.log('🔑 [TokenService] getToken called');
    try {
      // Prioritize localStorage for consistency with API service
      const localToken = localStorage.getItem(AUTH_TOKEN_KEY);
      
      if (localToken) {
        console.log('🔑 [TokenService] Token found in localStorage:', {
          length: localToken.length,
          preview: localToken.substring(0, 10) + '...'
        });
        return localToken;
      }
      
      // Fallback to sessionStorage
      const sessionToken = sessionStorage.getItem(AUTH_TOKEN_KEY);
      
      if (sessionToken) {
        console.log('🔑 [TokenService] Token found in sessionStorage:', {
          length: sessionToken.length,
          preview: sessionToken.substring(0, 10) + '...'
        });
        
        // Sync to localStorage for future consistency
        localStorage.setItem(AUTH_TOKEN_KEY, sessionToken);
        
        return sessionToken;
      }
      
      console.log('🔑 [TokenService] No token found in any storage');
      return null;
    } catch (error) {
      console.error('🔑 [TokenService] Error retrieving token:', error);
      return null;
    }
  },
  
  /**
   * Remove token from all storage
   */
  removeToken(): void {
    try {
      localStorage.removeItem(AUTH_TOKEN_KEY);
      sessionStorage.removeItem(AUTH_TOKEN_KEY);
      console.log('Token removed from storage');
    } catch (error) {
      console.error('Error removing token:', error);
    }
  },
  
  /**
   * Check if a valid token exists
   */
  hasValidToken(): boolean {
    const token = this.getToken();
    const isValid = !!token && token !== 'null' && token !== 'undefined';
    
    console.log('🔑 [TokenService] Token validation:', {
      exists: !!token,
      isValid,
      length: token?.length || 0
    });
    
    return isValid;
  }
};

export default tokenService; 